import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApiCatalogCreateComponent } from './api-catalog-create/api-catalog-create.component';
import { ApiCatalogUpdateComponent } from './api-catalog-update/api-catalog-update.component';
import { ApiCatalogViewComponent } from './api-catalog-view/api-catalog-view.component';
import { ApiCatalogDetailsComponent } from './api-catalog-details/api-catalog-details.component';
import { BaseAppRouteGuardService } from '../core/services/base-app-route-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'view',
    pathMatch: 'full'
  },
  {
    path: 'view',
    component: ApiCatalogViewComponent,
    canActivate: [BaseAppRouteGuardService],
    data: {
      Permission : 'API_CAT_LIST',
      title: "API Catalog List"
    }
  },
  {
    path: 'create',
    component: ApiCatalogCreateComponent,
    canActivate: [BaseAppRouteGuardService],
    data: {
      Permission : 'API_CAT_ADD',
      title: "Create API Catalog"
    }
  },
  {
    path: 'update/:id',
    component: ApiCatalogUpdateComponent,
    canActivate: [BaseAppRouteGuardService],
    data: {
      Permission : 'API_CAT_EDIT',
      title: "Edit API Catalog"
    }
  },
  {
    path: 'details/:id',
    component: ApiCatalogDetailsComponent,
    canActivate: [BaseAppRouteGuardService],
    data: {
      Permission : 'API_CAT_DETAILS',
      title: "API Catalog Details"
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApiCatalogPageRoutingModule {}
